import React from 'react';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import MaterialSnackbar from '@mui/material/Snackbar';
import c from 'classnames';

import Typography from '../Typography';
import { renderNodeOrComponent } from '../utils';
import { AUTO_HIDE_DURATION, DEFAULT_TRANSITION_DURATION } from './consts';
import {
  ICON_CLASSES,
  SNACKBAR_CONTAINER_CLASSES,
  snackbarExitingStyles,
  TRANSITION_PROPS,
} from './styles';
import { SnackbarProps } from './types';
import { getDefaultIcon } from './utils';

const SnackbarBody = (props: SnackbarProps) => {
  const {
    action = null,
    appearance = 'primary',
    classes,
    duration = AUTO_HIDE_DURATION,
    iconStatus = 'info',
    message,
    onClose,
    open,
    position = { horizontal: 'left', vertical: 'bottom' },
    startIcon,
    StartIcon,
    transitionDuration = DEFAULT_TRANSITION_DURATION,
  } = props;

  const containerClasses = SNACKBAR_CONTAINER_CLASSES[appearance];
  const iconStatusClasses = ICON_CLASSES[iconStatus];
  const icon =
    renderNodeOrComponent({ Component: StartIcon, node: startIcon }) ??
    getDefaultIcon({ appearance, iconStatus });

  const alertClasses = {
    icon: c('p-0 opacity-100', iconStatusClasses),
    message: 'p-0',
    root: c('rounded-8 flex items-center', containerClasses),
  };

  return (
    <MaterialSnackbar
      TransitionComponent={Slide}
      TransitionProps={TRANSITION_PROPS}
      anchorOrigin={position}
      autoHideDuration={duration}
      className={snackbarExitingStyles}
      classes={classes}
      open={open}
      transitionDuration={transitionDuration}
      onClose={onClose}>
      <Alert action={action} classes={alertClasses} icon={icon}>
        <Typography className="break-words" color="text-text-white" variant="body-short-02">
          {message}
        </Typography>
      </Alert>
    </MaterialSnackbar>
  );
};

export default SnackbarBody;
